// Never import any server-only code here, this is also used on the client side...
import type { TranslationsMap } from './types';

// Romanian version of the translation file
export const translations: TranslationsMap = {
  emails: {
    footer: {
      kindRegards: 'Cu stimă,',
      questionsOrProblems: 'Întrebări sau probleme?',
      contactUs: 'Contactați-ne',
    },
    transportOrder: {
      confirm: 'Confirmă',
      refuse: 'Refuză',
    },
    forgotPassword: {
      resetLink: 'Configurați o parolă nouă',
    },
    userInvite: {
      view: 'Vezi invitația',
    },
    attachments: {
      quotation: 'Ofertă {{reference}}',
    },
    customerComplaintAlert: {
      order: 'Vezi comanda',
    },
  },
  truckDocumentType: {
    Insurance: 'Asigurare',
    Examination: 'Inspecție',
  },
  orderDocumentType: {
    cmr: 'CMR',
    deliveryNote: 'Delivery note',
    weighSlip: 'Weigh slip',
    palletNote: 'Pallet note',
    annexII: 'Annex II',
    t1Document: 'T1 document',
    annexVII: 'Annex VII',
    saleInvoice: 'Invoice',
    transportOrder: 'Transport order',
    orderConfirmation: 'Order confirmation',
    sustainabilityReport: 'Sustainability report',
    customerAttachment: 'Customer attachment',
    planning: 'Planning',
    other: 'Other',
  },
  documentRejection: {
    subject: 'Document respins pentru comanda {{orderNumber}}',
    intro: 'Nu am putut aproba documentul {{documentType}} primit pentru comanda {{orderNumber}}. Motive:',
    outro: 'Vă rugăm să retrimiteți un document corect prin canalul obișnuit sau prin portalul transportatorului.',
    MissingSignature: 'Lipsește semnătura destinatarului pe CMR.',
    WrongCustomer: 'Clientul de pe document nu corespunde clientului acestei comenzi.',
    WrongOrgOnDocument: 'Expeditorul de pe document nu corespunde organizației noastre.',
    NoOrderReference: 'Nu am găsit nicio referință validă de comandă sau factură pentru a lega documentul.',
    WrongDocumentType: 'Tipul documentului nu corespunde celui așteptat pentru această comandă.',
    LowQuality: 'Calitatea scanării/fotografiei este prea scăzută pentru a valida fiabil conținutul.',
  },
  trailerTypes: {
    BoxTrailer: 'Remorcă închisă',
    FlatBed: 'Platformă',
    Mega: 'Remorcă Mega',
    Refrigerated: 'Frigorific',
    RoadTrain: 'Tren rutier',
    Tautliner: 'Prelată',
    Joloda: 'Prelată / Joloda',
    TautlinerCoil: 'Prelată / Coil',
  },
  loadingMethods: {
    Back: 'Spate',
    Side: 'Lateral',
    Top: 'Prin acoperiș',
  },
  documents: {
    note: {
      extraInformation: 'Informații suplimentare',
    },
    letter: {
      letter: 'Scrisoare',
    },
    paymentReminder: {
      invoiceNumber: 'Număr factură',
      invoiceDate: 'Data facturii',
      dueDate: 'Data scadenței',
      amount: 'Sumă',
      expiredAmount: 'Sumă expirată',
      currency: 'Monedă',
      totalOutstanding: 'Total outstanding',
      salutation: 'Dear Sir or Madam,',
      subject: {
        first: 'Subject: payment reminder — {{reference}}',
        second: 'Subject: second payment reminder — {{reference}}',
        third: 'Subject: third payment reminder — {{reference}}',
        final: 'Subject: notice of default — {{reference}}',
      },
      intro: {
        first:
          'Our records show that the invoices below have not yet been settled. If your payment has crossed with this letter, please disregard it.',
        second: 'Despite our earlier reminder, we have not yet received payment for the invoices below:',
        third: 'Despite repeated reminders, the invoices below are still outstanding:',
        final: 'Despite earlier payment reminders, we have to date received no payment for the invoices below:',
      },
      request:
        'We request that you transfer the outstanding amount of {{amount}} to the account below within {{days}} calendar days of receiving this letter, quoting the reference:',
      acknowledgement:
        'If you do not pay and do not state a reason for this, it will be regarded as an acknowledgement of the debt.',
      escalation: {
        first: 'Should we not receive your payment within this period, we will send you a further reminder.',
        second: 'Should we not receive your payment within this period, we will be obliged to escalate this file.',
        third:
          'Should payment not be made within this period, this file will be transferred to our debt collection procedure.',
        final:
          'Should payment not be made within this period, we will hand this file to our legal counsel without further notice, with instructions to start legal proceedings against you. The costs of this will be entirely at your expense.',
      },
      closing: {
        first: 'We trust you will settle the outstanding amount within the requested period.',
        second: 'We trust you will settle the outstanding amount within the requested period.',
        third: 'We trust you will settle the outstanding amount within the requested period.',
        final:
          'We trust this will not be necessary and that you will settle the outstanding amount within the requested period.',
      },
      sincerely: 'Sincerely,',
      signature: 'Accounting {{company}}',
      account: 'Account {{company}}',
      accounts: 'Conturi {{company}}',
      reference: 'Reference',
      amountDue: 'Amount due',
      bic: 'BIC',
      heldBy: 'titular {{company}}',
      date: 'Date',
      ourReference: 'Our reference',
      customerNumber: 'Customer number',
      yourVatNumber: 'Your VAT number',
      contact: 'Contact',
      phone: 'Phone',
    },
    quotation: {
      quotation: 'Ofertă',
      customerNumber: 'Număr client',
      reference: 'Referință',
      date: 'Data ofertei',
      dueDate: 'Data expirării',
      from: 'De la',
      to: 'La',
      volume: 'Volum',
      price: 'Preț',
      generalTermsAndConditions: 'Condițiile generale de vânzare atașate',
      questionsOrComments: 'Pentru întrebări, contactați-ne prin e-mail la {{email}}',
      trailerTypes: 'Tipuri de remorci',
    },
    transportOrder: {
      trailerTypes: 'Tipuri de remorci',
      loadingMethod: 'Mod de încărcare',
      transportOrder: 'Comandă de transport',
      date: 'Data',
      orderRef: 'Referință comandă',
      load: 'Încărcare',
      unload: 'Descărcare',
      reference: 'Referință',
      goods: 'Mărfuri',
      description: 'Descriere',
      packageType: 'Tip palet',
      palletCount: 'Paleți',
      weight: 'Greutate',
      LoadingMeter: 'Metru de încărcare',
      freightRate: 'Tarif de transport',
      price: 'Preț',
      vat: 'TVA',
      questionsOrComments: 'Întrebări sau comentarii?',
      contactFileManager: 'Nu ezitați să contactați managerul de fișiere',
      anonymousCmr: 'PENTRU ACEASTĂ COMANDĂ TREBUIE CREAT UN CMR ANONIM.',
      phone: 'Telefon',
      email: 'E-mail',
    },
    planning: {
      planning: 'Planificare',
      licensePlate: 'Număr de înmatriculare',
      codeName: 'Nume de cod',
    },
    kilometers: {
      full: 'Kilometri încărcați',
      empty: 'Kilometri goi',
      total: 'Total kilometri',
      planningTotal: 'Total pentru această planificare',
    },
    orderConfirmation: {
      orderConfirmation: 'Confirmare comandă',
      dearCustomer: 'Stimate client,',
      herebyWeConfirmYourOrder: 'Prin prezenta confirmăm comanda dvs. pentru următorul transport:',
      date: 'Data',
      ourReference: 'Referința noastră',
      yourReference: 'Referința dvs.',
      load: 'Încărcare',
      unload: 'Descărcare',
      reference: 'Referință',
      goods: 'Mărfuri',
      description: 'Descriere',
      packageType: 'Tip palet',
      palletCount: 'Paleți',
      weight: 'Greutate',
      LoadingMeter: 'Metru de încărcare',
      freightRate: 'Tarif de transport',
      price: 'Preț',
      vat: 'TVA',
      questionsOrComments: 'Întrebări sau comentarii?',
      contactFileManager: 'Nu ezitați să contactați managerul de fișiere',
      phone: 'Telefon',
      email: 'E-mail',
    },
    orderCancellation: {
      orderCancellation: 'Anulare comandă',
      dearCustomer: 'Stimate client,',
      orderCancelledText: 'Comanda dvs. pentru transportul de mai jos a fost anulată:',
      date: 'Data',
      ourReference: 'Referința noastră',
      yourReference: 'Referința dvs.',
      load: 'Încărcare',
      unload: 'Descărcare',
      reference: 'Referință',
      goods: 'Mărfuri',
      description: 'Descriere',
      packageType: 'Tip palet',
      palletCount: 'Paleți',
      weight: 'Greutate',
      LoadingMeter: 'Metru de încărcare',
      freightRate: 'Tarif de transport',
      price: 'Preț',
      vat: 'TVA',
      questionsOrComments: 'Întrebări sau comentarii?',
      contactFileManager: 'Nu ezitați să contactați managerul de fișiere',
      phone: 'Telefon',
      email: 'E-mail',
    },
    invoice: {
      invoice: 'Factură',
      customerNumber: 'Număr client',
      invoiceNumber: 'Număr factură',
      invoiceDate: 'Data facturii',
      dueDate: 'Data scadenței',
      load: 'Încărcare',
      unload: 'Descărcare',
      ourReference: 'Referința noastră',
      yourReference: 'Referința dvs.',
      description: 'Descriere',
      quantity: 'Cantitate',
      unitPrice: 'Preț unitar',
      total: 'Total',
      vat: 'TVA',
      paymentInformation: 'Informații de plată',
      amountToPay: 'Suma de plată',
      toBePaidBefore: 'De plătit înainte de',
      beneficiary: 'Beneficiar',
      message: 'Mesaj',
      generalTermsAndConditions: 'Condițiile generale de vânzare atașate',
      questionsOrComments: 'Pentru orice întrebări, vă rugăm să contactați contabilitatea la {{email}}',
    },
    sustainabilityReport: {
      sustainabilityReport: 'Raport de sustenabilitate',
      date: 'Data',
      ourReference: 'Referința noastră',
      yourReference: 'Referința dvs.',
      truck: 'Camion',
      distance: 'Distanță',
      weight: 'Greutate',
      emissions: 'Emisii',
      questionsOrComments: 'Întrebări sau observații?',
      contactFileManager: 'Nu ezitați să contactați managerul de fișiere',
      phone: 'Telefon',
      email: 'E-mail',
    },
    globalSustainabilityReport: {
      sustainabilityReport: 'Raport de sustenabilitate',
      date: 'Data',
      startDate: 'Data de începere',
      endDate: 'Data de încheiere',
      orderCount: 'Număr de comenzi',
      truck: 'Camion',
      totals: 'Total',
      distance: 'Distanță',
      weight: 'Greutate',
      emissions: 'Emisii CO2',
      averagePerOrder: 'Medie pe comandă',
      framework:
        'Pentru detalii despre calculul emisiilor, vă rugăm să consultați politica de sustenabilitate de pe site-ul nostru.',
      questionsOrComments: 'Întrebări sau comentarii?',
      contactFileManager: 'Nu ezitați să contactați managerul de fișiere',
      phone: 'Tel.',
      email: 'Email',
    },
    rideOverview: {
      title: 'Prezentare generală',
      entryNumber: 'Referință prezentare',
      dossier: 'Dosar',
      draftBanner: 'Ciornă — încă neaprobată',
      invoiceRequestNotice:
        'Acest document nu este o factură de autofacturare validă. La primirea acestei prezentări, {{customer}} așteaptă de la dumneavoastră o factură pentru aceste comenzi.',
    },
    selfBill: {
      title: 'Autofacturare',
      number: 'Nr.',
      draftBanner: 'Ciornă — încă neaprobată',
      supplierLabel: 'Furnizor — transportator · plătim această companie',
      customerLabel: 'Client — emite această factură în numele furnizorului',
      vatCompanyNumber: 'CIF / nr. înregistrare:',
      vatShort: 'CIF',
      carrierNumber: 'Număr transportator: {{number}}',
      customerRegister: 'RLE Gent, division Kortrijk',
      bankLabel: 'Plată în contul bancar al furnizorului',
      bankNotice:
        'Înregistrat în fișierul nostru de transportatori. Dacă acesta nu este contul dumneavoastră, contactați imediat {{email}}. Datele bancare se modifică doar prin procedura noastră de verificare, niciodată pe baza unei solicitări prin e-mail.',
      documentType: 'Tip document',
      invoiceNumber: 'Număr factură',
      invoiceDate: 'Data facturii',
      servicePeriod: 'Perioada prestării',
      agreement: 'Acord',
      paymentDate: 'Data plății',
      natureOfServices:
        'Natura serviciilor: {{nature}}, o cursă pe rând, efectuată la data expedierii indicată. Preț unitar = valoarea rândului (cantitate 1), fără TVA.',
      roadFreightTransport: 'transport rutier de mărfuri',
      columnNumber: 'Nr.',
      columnFile: 'Dosar',
      columnShipmentDate: 'Data expedierii',
      columnLoading: 'Încărcare',
      columnUnloading: 'Descărcare',
      columnQuantity: 'Cant.',
      columnVat: 'TVA',
      columnAmount: 'EUR',
      tripCountOne: '1 cursă pe această factură',
      tripCountOther: 'Curse pe această factură: {{count}}',
      totalServices: 'Total servicii de transport (fără TVA)',
      earlyPaymentDiscount: 'Reducere pentru plată anticipată {{percentage}}',
      earlyPaymentCondition:
        'La plata în termen de 7 zile se deduce o reducere de {{percentage}} ({{amount}}). De plată: {{withDiscount}}. După acest termen: {{withoutDiscount}}.',
      taxableAmount: 'Baza de impozitare {{rate}}',
      vat: 'TVA {{rate}}',
      totalToPay: 'Total de plată',
      paymentNotice:
        '{{amount}} va fi virată automat la data de {{date}} în contul {{iban}}. Nu este necesară nicio acțiune din partea dumneavoastră.',
      paymentNoticeWithoutAccount:
        '{{amount}} va fi virată automat la data de {{date}}. Nu este necesară nicio acțiune din partea dumneavoastră.',
      yourInvoiceTitle:
        'Aceasta este factura dumneavoastră. Vă rugăm să nu ne trimiteți o factură pentru aceste curse.',
      yourInvoice:
        'Acest document este emis de {{customer}} în numele și pe seama {{supplier}}, în baza acordului de autofacturare dintre cele două părți. Nu este o propunere. O factură trimisă de dumneavoastră pentru aceleași curse va fi respinsă ca duplicat.',
      acceptanceTitle: 'Acceptare',
      acceptance:
        'Factura se consideră acceptată de furnizor, cu excepția cazului în care este contestată în scris la {{email}} în termen de 7 zile de la data facturii. Corecțiile se fac printr-o notă de credit în regim de autofacturare.',
      paymentTermTitle: 'Termen de plată',
      paymentTerm:
        'Termenul de plată este cel convenit în contractul dumneavoastră. Dacă s-a acordat o reducere, termenul de plată este de 7 zile.',
      missingTripTitle: 'Lipsește o cursă?',
      missingTrip:
        'O cursă nu apare pe această factură deoarece documentele ei nu sunt în regulă. Încărcați documentele corecte în portalul transportatorului și cursa va fi inclusă pe următoarea factură.',
      questionsTitle: 'Întrebări?',
      questions: 'Contactați {{email}}, menționând numărul facturii.',
      legalSelfBilling: 'Autofacturare',
      legalNotice:
        '{{selfBilling}} — factură emisă de client în numele și pe seama furnizorului (art. 224 și 226 pct. 10a din Directiva 2006/112/CE) · Acord de autofacturare {{agreement}} · Peppol BIS Self-Billing 3.0, tip document 389',
      legalTerms:
        'Condiții generale de vânzare anexate și disponibile pe {{website}} · Se aplică legea belgiană · Instanțele din Kortrijk',
      pageFooter: '{{title}} {{number}} · {{company}}',
      page: 'Pagina {{page}} din {{total}}',
    },
    creditNote: {
      creditNote: 'Notă de credit',
      customerNumber: 'Număr client',
      creditNoteNumber: 'Număr notă de credit',
      date: 'Data',
      dueDate: 'Data scadenței',
      load: 'Încărcare',
      unload: 'Descărcare',
      ourReference: 'Referința noastră',
      yourReference: 'Referința dvs.',
      description: 'Descriere',
      quantity: 'Cantitate',
      unitPrice: 'Preț unitar',
      total: 'Total',
      vat: 'TVA',
      paymentInformation: 'Informații de plată',
      amountToPay: 'Suma de plată',
      toBePaidBefore: 'De plătit înainte de',
      payer: 'Plătitor',
      message: 'Mesaj',
      generalTermsAndConditions: 'Condițiile generale de vânzare atașate',
      questionsOrComments: 'Pentru orice întrebări, vă rugăm să contactați contabilitatea la {{email}}',
    },
    carrierTruckReport: {
      title: 'Truck performance report',
      truckname: 'Name',
      totalIncome: 'Total income',
      totalKm: 'Total kilometers',
    },
    totals: {
      totalExclVat: 'Total fără TVA',
      totalVat: 'Total TVA',
      totalInclVat: 'Total cu TVA',
      cashDiscount: 'Discount pentru plată anticipată',
      netAmountToPay: 'Sumă netă de plată',
      vatReverseCharged: 'TVA taxare inversă, articolul 44 Directiva TVA',
    },
  },
  carrierTerms: {
    agreement: 'Accept {{terms}}, inclusiv procedura de autofacturare.',
    termsLink: 'condițiile generale',
  },
  pages: {
    confirmOrderStates: {
      headingRefused: 'Comanda a fost refuzată',
      headingCancelled: 'Comanda a fost anulată',
      headingConfirmed: 'Comanda a fost confirmată',
      headingUnknownStatus: 'Comanda a fost deja executată sau starea este necunoscută',
    },
    confirmOrderPlanningStates: {
      headingRefused: 'Planificarea a fost refuzată',
      headingCancelled: 'Planificarea a fost anulată',
      headingConfirmed: 'Planificarea a fost confirmată',
      headingUnknownStatus: 'Planificarea a fost deja executată sau starea este necunoscută',
    },
    confirmOrder: {
      heading: 'Confirmă comanda de transport {{order.orderNumber}}',
      orderConfirmed: 'Comandă confirmată',
      orderConfirmationError: 'Nu s-a putut confirma comanda: {{error}}',
      confirmButton: `Confirmă comanda de transport`,
    },
    confirmPlanning: {
      heading: 'Confirmă planificarea {{planningDate}}',
      planningConfirmed: 'Planificare confirmată',
      confirmButton: `Confirmă planificarea`,
    },
    refuseOrder: {
      heading: 'Refuză comanda de transport {{order.orderNumber}}',
      orderRefused: 'Comandă refuzată',
      orderRefusalError: 'Nu s-a putut refuza comanda: {{error}}',
      refuseButton: `Refuză comanda de transport`,
    },
    refusePlanning: {
      heading: 'Refuză planificarea {{planningDate}}',
      planningRefused: 'Planificare refuzată',
      refuseButton: `Refuză planificarea`,
    },
    orderSummary: {
      loadAndUnloadInformation: 'Informații de încărcare și descărcare',
      load: 'Încărcare',
      unload: 'Descărcare',
      freightRate: 'Tarif de transport',
      total: 'Total',
    },
  },
  portal: {
    requestAccount: {
      requestCustomerAccount: 'Solicitați un cont ca client',
      requestCarrierAccount: 'Solicitați un cont ca transportator',
      success: 'Cererea a fost trimisă, vă vom contacta pentru pașii următori.',
      failed: 'Nu s-a putut solicita contul: {{error}}',
      name: 'Nume',
      email: 'Email',
      companyName: 'Numele companiei',
      companyNumber: 'Număr de înregistrare al companiei',
      request: 'Solicitare',
      dontHaveAnAccount: 'Nu aveți încă un cont?',
      accountRequestFailed: 'Solicitarea contului a eșuat',
    },
  },
  customerPortal: {
    switch: 'Schimbă clientul',
    selectCustomer: 'Selectați clientul',
    requestAccount: {
      title: 'Solicitați un cont',
      success: 'Cererea a fost trimisă, vă vom contacta pentru pașii următori.',
      failed: 'Nu s-a putut solicita contul: {{error}}',
      name: 'Nume',
      email: 'Email',
      companyName: 'Numele companiei',
      companyNumber: 'Număr de înregistrare al companiei',
      request: 'Solicitare',
      dontHaveAnAccount: 'Nu aveți încă un cont?',
    },
    invite: {
      title: 'Invitat la Portalul pentru Clienți',
      details: 'Ați fost invitat la portalul pentru clienți TransDirect, creați-vă contul introducând parola.',
      accepted: 'Invitație acceptată, veți fi redirecționat la pagina principală în scurt timp.',
      acceptError: 'Nu s-a putut accepta invitația: {{error}}',
      acceptButtonText: 'Acceptă Invitația',
      password: 'Parola',
      repeatPassword: 'Repetă Parola',
    },
    home: {
      customerPortal: 'Portalul clientului',
      title: 'Portalul clientului',
      hello: 'Salut,',
      welcome: 'Bun venit pe portalul clientului.',
      manageOrders: 'Gestionați toate comenzile de transport.',
      viewInvoices: 'Vizualizați și plătiți facturile cu ușurință.',
      createQuotes: 'Creați și urmăriți oferte.',
      viewLocations: 'Vizualizați toate locațiile de transport.',
    },
    locations: {
      locations: 'Locații',
      location: 'Locație',
      name: 'Nume',
      street: 'Stradă',
      number: 'Număr',
      countryCode: 'Cod țară',
      postalCode: 'Cod poștal',
      city: 'Oraș',
      country: 'Țară',
      language: 'Limbă',
      notes: 'Note',
      createLocation: 'Creează locație',
      newLocation: 'Locație nouă',
      locationCreated: 'Locație creată',
      couldNotCreateLocation: 'Nu s-a putut crea locația: {{error}}',
      findLocation: 'Găsește o locație...',
      address: 'Adresă',
      locationNotFound: 'Locație negăsită',
      couldNotLoadLocation: 'Nu s-a putut încărca locația: {{error}}',
    },
    order: {
      duplicate: 'Duplicat',
      bulkDuplicate: 'Duplicare în masă',
      bulkDuplicateTitle: 'Duplicare comandă în masă',
      bulkDuplicateDescription: 'Creați mai multe copii ale acestei comenzi cu referințe de factură incrementate.',
      numberOfDuplicates: 'Număr de duplicate',
      baseInvoiceRef: 'Referință factură de start',
      baseInvoiceRefHelper:
        'Bază numerică. Zerourile din față vor fi eliminate. Referințele vor fi bază până la bază+număr-1.',
      skipDraft: 'Sari peste statusul de ciornă (direct ca Creat)',
      bulkDuplicateSuccess: '{{count}} comenzi create',
      bulkDuplicateError: 'Nu s-au putut duplica comenzile: {{error}}',
      referencePreview: 'Referințe: {{first}} până la {{last}}',
      overview: 'Prezentare generală',
      updateInvoiceRef: 'Actualizează referința facturii',
      updated: 'Comanda a fost actualizată',
      couldNotUpdate: 'Nu s-a putut actualiza comanda: {{error}}',
    },
    orders: {
      orders: 'Comenzi',
      placeOrder: 'Plasați o comandă',
      invoiceRef: 'Referință factură',
      orderRef: 'Referință comandă',
      loadLocation: 'Locație de încărcare',
      unloadLocation: 'Locație de descărcare',
      loadDate: 'Data încărcării',
      loadTime: 'Ora încărcării',
      unloadDate: 'Data descărcării',
      unloadTime: 'Ora descărcării',
      invoiceTotal: 'Total factură',
      status: 'Stare',
      invoiceStatus: 'Stare factură',
      hasCMR: 'Are CMR',
      creationDate: 'Data creării',
      executionDate: 'Data executării',
      fileManager: 'Manager de fișiere',
      cancellationReason: 'Motivul anulării',
      stops: 'Opriri',
      deleteStop: 'Șterge oprire',
      purchases: 'Achiziții',
      total: 'Total',
      trailerTypes: 'Tipuri de remorci',
      loadingMethod: 'Mod de încărcare',
      load: 'Încărcare',
      unload: 'Descărcare',
      typeStop: 'Tip oprire',
      extraNotes: 'Note suplimentare',
      noContent: 'Fără conținut',
      packaging: 'Ambalaj',
      coli: 'Colete',
      content: 'Conținut',
      addContent: 'Adaugă conținut',
      deleteContent: 'Șterge conținut',
      noStops: 'Fără opriri',
      noStopsError: 'Adăugați cel puțin o oprire de încărcare și descărcare',
      reference: 'Referință',
      complaints: 'Reclamații',
      fileComplaint: 'Depuneți o reclamație',
      fileComplaintDescription: 'Completați acest formular pentru a depune o reclamație',
      send: 'Trimite',
      reason: 'Motiv',
      details: 'Detalii',
      complaintFiled: 'Reclamație depusă',
      couldNotFileComplaint: 'Nu s-a putut depune reclamația: {{error}}',
      placeAnOrder: 'Plasați o comandă',
      assignment: 'Sarcină',
      addStop: 'Adaugă oprire',
      location: 'Locație',
      date: 'Data',
      start: 'Start',
      stop: 'Oprire',
      weight: 'Greutate (kg)',
      volume: 'Volum (m3)',
      loadMeter: 'Metru de încărcare',
      stopsRequired: 'Este necesară cel puțin 1 oprire',
      contentRequired: 'Este necesar cel puțin 1 element de conținut',
      truck: 'Camion',
      distance: 'Distanță',
      emissions: 'Emisii',
      sustainability: 'Sustenabilitate',
      attachments: 'Atașamente',
      uploadAttachments: 'Încarcă atașamente',
      attachmentDeleted: 'Atașament șters',
      couldNotDeleteAttachment: 'Nu s-a putut șterge atașamentul: {{error}}',
      uploadedAttachment: 'Atașament {{document}} încărcat',
      uploadFailed: 'Nu s-a putut încărca atașamentul {{document}}: {{error}}',
      route: 'Traseu',
      chooseMethod: 'Alegeți o metodă',
      automatic: 'Automat',
      automaticDescription:
        'Încărcați unul sau mai multe PDF-uri cu comenzi de transport și AI-ul nostru va extrage automat detaliile comenzii. Fiecare PDF devine o comandă separată.',
      manual: 'Manual',
      manualDescription: 'Completați singur formularul de comandă cu toate opririle, marfa și detaliile de livrare.',
      uploadPdfs: 'Încărcați PDF-urile comenzilor de transport',
      processingPdf: 'Se procesează PDF-ul...',
      createOrders: 'Creați comenzi',
      orderCreated: 'Comandă creată',
      ordersCreated: '{{count}} comenzi create',
      couldNotCreateFromPdf: 'Nu s-a putut crea comanda din PDF: {{error}}',
      uploadAtLeastOnePdf: 'Încărcați cel puțin un PDF',
      viewOrder: 'Vizualizați comanda',
      creatingOrders: 'Se creează comenzile...',
      report: 'Raport',
      orderPlaced: 'Comandă plasată',
      couldNotPlaceOrder: 'Nu s-a putut plasa comanda: {{error}}',
      stopNumber: 'Oprire {{number}} - {{type}}',
      orderLink: 'Comandă {{orderNumber}} - {{customerRef}}',
    },
    quotes: {
      quotes: 'Oferte',
      quote: 'Ofertă',
      quoteReference: 'Referință ofertă',
      quoteDate: 'Data ofertei',
      expirationDate: 'Data expirării',
      total: 'Total',
      search: 'Căutați o ofertă...',
      quotation: 'Ofertă {{reference}}',
      notFound: 'Ofertă negăsită',
      departurePlace: 'Loc de plecare',
      destination: 'Destinație',
      distance: 'Distanță',
      price: 'Preț',
      type: 'Tip',
      requests: 'Oferte solicitate',
      request: 'Solicită o ofertă',
      requestTitle: 'Cerere de ofertă {{reference}}',
      notes: 'Note',
      lines: 'Linii de ofertă',
      addLine: 'Adaugă linie',
      noLines: 'Fără linii de ofertă',
      requestSuccess: 'Ofertă solicitată',
      requestFailed: 'Nu s-a putut solicita oferta: {{error}}',
      requestedAt: 'Solicitat la',
      quotationRequests: 'Cereri de ofertă',
      hasQuote: 'Are ofertă',
      generalInformation: 'Informații generale',
      removeLine: 'Elimină linie',
    },
    quoteLine: {
      from: 'De la',
      to: 'La',
    },
    invoices: {
      invoices: 'Facturi',
      invoiceNumber: 'Număr factură',
      invoiceDate: 'Data facturii',
      dueDate: 'Data scadenței',
      total: 'Total',
      search: 'Căutați o factură...',
      notFound: 'Factură negăsită',
      invoice: 'Factura {{invoiceNumber}}',
      structuredComment: 'Comentariu structurat',
      reference: 'Referință',
      sentAt: 'Trimis la',
      load: 'Încărcare',
      unload: 'Descărcare',
      description: 'Descriere',
      amount: 'Sumă',
      unitPrice: 'Preț unitar',
      vat: 'TVA',
      extraInformation: 'Informații suplimentare: {{extraInformation}}',
      orderTotal: 'Total comandă: €{{total}}',
      totalExclVat: 'Total fără TVA:',
      totalVat: 'Total TVA:',
      totalInclVat: 'Total cu TVA:',
      generalInformation: 'Informații generale',
    },
    creditNotes: {
      creditNotes: 'Note de credit',
      creditNoteNumber: 'Număr notă de credit',
      creditNoteDate: 'Data notei de credit',
      dueDate: 'Data scadenței',
      total: 'Total',
      search: 'Căutați o notă de credit...',
      notFound: 'Notă de credit negăsită',
      creditNote: 'Nota de credit {{creditNoteNumber}}',
      structuredComment: 'Comentariu structurat',
      reference: 'Referință',
      sentAt: 'Trimis la',
      load: 'Încărcare',
      unload: 'Descărcare',
      description: 'Descriere',
      amount: 'Sumă',
      unitPrice: 'Preț unitar',
      vat: 'TVA',
      extraInformation: 'Informații suplimentare: {{extraInformation}}',
      orderTotal: 'Total comandă: €{{total}}',
      totalExclVat: 'Total fără TVA:',
      totalVat: 'Total TVA:',
      totalInclVat: 'Total cu TVA:',
      generalInformation: 'Informații generale',
    },
    businessInformation: {
      businessInformation: 'Informații despre afacere',
      updateBusinessInformation: 'Actualizați informațiile despre afacere',
      name: 'Nume',
      vatNumber: 'Număr TVA',
      businessNumber: 'Număr de înregistrare al companiei',
      saveChanges: 'Salvează modificările',
      informationChanged: 'Informațiile au fost actualizate',
      informationNotChanged: 'Nu s-au putut actualiza informațiile: {{error}}',
      requestChanges:
        'Pentru a actualiza numele companiei, numărul de TVA sau numărul de înregistrare al companiei, vă rugăm să ne contactați',
    },
    ourInformation: {
      ourInformation: 'Informații despre compania TransDirect',
      name: 'Nume',
      vatNumber: 'Număr TVA',
      businessNumber: 'Număr de înregistrare al companiei',
      address: 'Adresă',
      contact: 'Contact',
      phoneNumber: 'Număr de telefon',
      emailTransport: 'Email transport',
      emailAccounting: 'Email contabilitate',
      emailGeneral: 'Email general',
    },
    contacts: {
      contacts: 'Contacte',
      name: 'Nume',
      email: 'Email',
      phone: 'Telefon',
      function: 'Funcție',
      language: 'Limbă',
      notifications: 'Contact potrivit pentru',
      newContact: 'Contact nou',
      contactCreated: 'Contact creat',
      couldNotCreateContact: 'Nu s-a putut crea contactul: {{error}}',
      createContact: 'Creează contact',
      notFound: 'Contact negăsit',
      updatedContact: 'Contact actualizat',
      couldNotUpdateContact: 'Nu s-a putut actualiza contactul: {{error}}',
      updateContact: 'Actualizează contactul',
      delete: 'Șterge',
      deleteContact: 'Șterge contact',
      deleteContactConfirmation: 'Sunteți sigur că doriți să ștergeți contactul {{name}}?',
      deleteContactError: 'Nu s-a putut șterge contactul: {{error}}',
      deleteContactSuccess: 'Contact șters',
    },
    users: {
      users: 'Utilizatori',
      inviteUser: 'Invită utilizator',
      invitedUsers: 'Utilizatori invitați',
      noInvitedUsers: 'Niciun utilizator invitat',
      removeInvite: 'Elimină invitația',
      confirmRemoveInvite: 'Sunteți sigur că doriți să eliminați invitația pentru {{email}}?',
      inviteRemoved: 'Invitație eliminată',
      couldNotRemoveInvite: 'Nu s-a putut elimina invitația: {{error}}',
      noUsersFound: 'Niciun utilizator găsit',
      removeUser: 'Elimină utilizator',
      confirmRemoveUser: 'Sunteți sigur că doriți să eliminați utilizatorul {{name}}?',
      userRemoved: 'Utilizator eliminat',
      couldNotRemoveUser: 'Nu s-a putut elimina utilizatorul: {{error}}',
      active: 'Activ',
      inactive: 'Inactiv',
      userInvited: 'Utilizator invitat',
      couldNotInviteUser: 'Nu s-a putut invita utilizatorul: {{error}}',
      name: 'Nume',
      email: 'Email',
      isActive: 'Este activ?',
      invited: 'Invitat',
    },
    cmrReminder: {
      cmrReminder: 'Memento CMR',
      sendReminder: 'Trimite',
      confirmText: 'Sunteți sigur că doriți să trimiteți un memento CMR?',
      confirmation: 'Memento CMR trimis',
      error: 'Nu s-a putut trimite mementoul CMR: {{error}}',
    },
    sustainability: {
      sustainability: 'Sustenabilitate',
      policy: 'Politică de sustenabilitate',
      viewOverview: 'Vezi prezentarea generală a sustenabilității',
      orderCount: 'Număr de comenzi',
      totalDistance: 'Distanță totală',
      totalWeight: 'Greutate totală',
      totalEmissions: 'Emisii totale de CO2',
      averageDistance: 'Distanță medie',
      averageWeight: 'Greutate medie',
      averageEmissions: 'Emisii medii de CO2',
      total: 'Total',
      avgPerOrder: 'Medie pe comandă',
    },
    settings: {
      settings: 'Setări',
    },
    apiKeys: {
      apiKeys: 'Chei API',
      createApiKey: 'Creează cheie API',
      name: 'Nume',
      scopes: 'Permisiuni',
      status: 'Status',
      lastUsed: 'Ultima utilizare',
      createdAt: 'Creată la',
      prefix: 'Prefix',
      active: 'Activă',
      revoked: 'Revocată',
      expired: 'Expirată',
      never: 'Niciodată',
      revokeApiKey: 'Revocă cheia API',
      confirmRevoke: 'Sigur doriți să revocați cheia API "{{name}}"? Această acțiune nu poate fi anulată.',
      apiKeyRevoked: 'Cheia API a fost revocată',
      couldNotRevoke: 'Nu s-a putut revoca cheia API: {{error}}',
      apiKeyCreated: 'Cheia API a fost creată',
      couldNotCreate: 'Nu s-a putut crea cheia API: {{error}}',
      copyKey: 'Copiază cheia',
      keyCopied: 'Cheie copiată',
      keyWarning: 'Păstrați această cheie în siguranță. Nu va mai fi afișată din nou.',
      noApiKeys: 'Nu s-au găsit chei API',
      ordersRead: 'Citire comenzi',
      ordersWrite: 'Creare comenzi',
      maxKeysReached: 'Numărul maxim de chei API a fost atins',
      scopeRequired: 'Este necesar cel puțin un domeniu',
    },
    loading: 'Se încarcă...',
  },
  liveTracking: {
    title: 'Urmărire',
    subtitle: 'Poziția și computerul de bord al acestui camion.',
    loading: 'Se preia poziția…',
    noPosition: 'Nu se cunoaște încă poziția acestui camion.',
    noPositionHint: 'Asociați un vehicul cu această placă de înmatriculare în pagina de integrări.',
    noConnection: 'Nicio conexiune de urmărire nu urmărește încă acest camion. Conectați una pentru a-i vedea poziția.',
    driving: 'Se deplasează',
    idle: 'Staționează',
    location: 'Poziție',
    speed: 'Viteză',
    heading: 'Direcție',
    odometer: 'Kilometraj',
    fuel: 'Combustibil',
    lastMeasurement: 'Ultima măsurătoare',
    liveActive: 'Urmărire live activă — se actualizează la fiecare 30 de secunde.',
    lastSignal: 'Ultimul semnal',
    trailer: 'Remorcă',
    refresh: 'Actualizează',
    startLive: 'Pornește urmărirea live',
    stopLive: 'Oprește urmărirea live',
    resizePanel: 'Redimensionează panoul lateral',
    connections: 'Conexiuni de urmărire',
    connectionsSubtitle: 'Conectați mediul de urmărire al unui furnizor pentru a le urmări camioanele.',
    addConnection: 'Adaugă o conexiune de urmărire',
    integrations: 'Integrări de urmărire',
    integrationsHint: 'Alegeți un furnizor pentru a conecta urmărirea unui transportator.',
    providerFleetmaster: 'Urmăriți poziția și computerul de bord al camioanelor prin FleetMaster.lt.',
    connectionLabel: 'Nume',
    connectionLabelHelp: 'Cum apare această conexiune în listă.',
    helpCompanyId: 'ID-ul companiei din contul tău de telematică FleetMaster.',
    helpSuivoBaseUrl: 'Lasă gol pentru mediul Suivo standard.',
    ownerLabel: 'ID furnizor',
    ownerHelp: 'Pentru o conexiune a unui transportator/furnizor.',
    credentialsNote: 'Cheia este stocată criptat și nu mai este afișată niciodată după salvare.',
    connect: 'Conectează',
    back: 'Înapoi',
    noConnections: 'Nicio conexiune de urmărire.',
    noConnectionsHint: 'Adăugați una pentru a vedea unde sunt camioanele.',
    moreConnectionsTitle: 'Mai multe conexiuni de urmărire în curând',
    moreConnectionsBody:
      'FleetMaster este primul furnizor. Lucrăm la mai multe conexiuni de urmărire — furnizorii noi apar aici automat.',
    connectionsLoading: 'Se încarcă conexiunile…',
    vehiclesLoading: 'Se încarcă vehiculele…',
    noVehicles: 'Această conexiune nu raportează încă vehicule.',
    statusActive: 'Activă',
    statusError: 'Eroare',
    keyLabel: 'cheie',
    linkedCount: '{{linked}} din {{total}} vehicule asociate',
    lastChecked: 'ultima verificare',
    never: 'niciodată',
    supplierOwner: 'Furnizor #{{id}}',
    connectionSettings: 'Setări conexiune',
    verify: 'Verifică',
    verifyOk: 'Conexiunea funcționează.',
    verifyFailed: 'Conexiunea nu a putut fi verificată.',
    remove: 'Șterge',
    removeTitle: 'Șterge conexiunea',
    removeDescription: 'Conexiunea „{{label}}” și cheia salvată vor fi șterse.',
    connectionRemoved: 'Conexiune ștearsă.',
    linkVehicles: 'Leagă vehicule',
    linkVehiclesHint: 'Alege un vehicul, apoi camionul în care rulează.',
    link: 'Asociază',
    unlink: 'Dezasociază',
    linkTruck: 'Asociază camionul',
    chooseTruck: 'Camion',
    chooseTruckHelp: 'Alegeți camionul în care circulă acest vehicul.',
    chooseTruckRequired: 'Alegeți un camion',
    moreTrucks: 'Sunt afișate doar primele {{count}} camioane — căutați pentru a restrânge lista.',
    plateMatch: 'placa de înmatriculare corespunde',
    linkedTo: 'Asociat cu {{truck}}',
    linkedManually: 'manual',
    notLinked: 'Neasociat',
    vehicleLinked: 'Vehicul asociat.',
    vehicleUnlinked: 'Asociere eliminată.',
    trailerSubtitle: 'Locația acestei remorci.',
    linkTracker: 'Leagă trackerul',
    linkTrackerHint: 'Alege vehiculul care se află în această remorcă.',
    linkTrailer: 'Leagă remorca',
    linkTrailerHint: 'Alege un vehicul, apoi remorca pe care se află.',
    chooseTrailer: 'Remorcă',
    chooseTrailerRequired: 'Alege o remorcă',
    noTrackerLinked: 'Niciun tracker nu este încă legat de această remorcă — leagă unul pentru a vedea locația.',
    noTrailerPosition: 'Locația acestei remorci nu este încă cunoscută.',
    searchUnits: 'Caută după nume sau număr…',
    noUnits: 'Niciun vehicul raportat încă.',
    providerSuivo: 'Urmărește locația remorcilor noastre cu trackere Suivo.',
    ownerKindLabel: 'Proprietar',
    ownerKindCompany: 'Flotă proprie (companie)',
    ownerKindCarrier: 'Transportator/furnizor',
    supplierOwnerCompany: 'Flotă proprie',
    status: {
      moving: 'În mișcare',
      parked: 'Parcat',
      idling: 'Ralanti',
      immobilized: 'Imobilizat',
      offline: 'Fără semnal',
      inOperation: 'În exploatare',
    },
    trailersMap: {
      searchLabel: 'Caută (ID TDR / nume / număr)',
      searchPlaceholder: 'Caută după nume sau număr...',
      trackerLabel: 'Tracker',
      trackerAll: 'Toate semiremorcile',
      trackerTracked: 'Cu tracker',
      trackerUntracked: 'Fără tracker',
      trackerSilent: 'Fără semnal > 24 h',
      tableCardTitle: 'Semiremorci',
      mapCardTitle: 'Hartă',
      tableTrailer: 'Semiremorcă',
      tablePlate: 'Număr',
      tableTracker: 'Tracker',
      tableStatus: 'Stare',
      tableLastSignal: 'Ultimul semnal',
      tablePlace: 'Loc',
      noTracker: 'Fără tracker',
      clearFilters: 'Șterge toate filtrele',
      noneTrackedTitle: 'Niciun tracker conectat încă',
      noneTrackedDescription: 'Conectați o unitate Suivo la o semiremorcă pentru a o vedea pe hartă.',
      noneInFilter: 'Nicio semiremorcă în această selecție',
      noConnectionsTitle: 'Nicio conexiune de urmărire',
      noConnectionsDescription: 'Adăugați o conexiune pentru a vedea unde se află semiremorcile noastre.',
      noConnectionsAction: 'Spre integrările de urmărire',
      connectionErrorTitle: 'Conexiune de urmărire cu eroare',
    },
  },
  carrierPortal: {
    liveTracking: { liveTracking: 'Urmărire' },
    selectCarrier: 'Selectați transportatorul',
    loading: 'Se încarcă...',
    switch: 'Schimbă transportatorul',
    home: {
      carrierPortal: 'Portal Transportator',
      title: 'Portal Transportator',
      hello: 'Salut,',
      welcome: 'Bun venit pe portalul transportatorului.',
      manageOrders: 'Gestionați toate comenzile de transport.',
      managePlanning: 'Gestionați-vă planificarea.',
      selfBilling: 'Creați și gestionați facturile de autofacturare.',
      info: 'Informații',
      infoSubtitle: 'Informații despre TransDirect și portalul transportatorului',
      contact: 'Persoană de contact',
      contactSubtitle: 'Cine este persoana dvs. de contact la TransDirect',
      FuelCard: 'Card de combustibil',
      FuelCardSubtitle: 'Solicitați cardul de combustibil personalizat TransDirect',
      saveChanges: 'Salvează modificările',
    },
    orders: {
      allAccepted: 'Toate comenzile confirmate',
      customerReference: 'Referință client',
      draft: 'Ciornă',
      load: 'Încărcare',
      orders: 'Comenzi',
      manageOrders: 'Gestionați toate transporturile și încărcați documentele de transport',
      orderRef: 'Referință-TD',
      loadLocation: 'Locație de încărcare',
      unload: 'Descărcare',
      unloadLocation: 'Locație de descărcare',
      invoiceTotal: 'Tarif de transport',
      hasCMR: 'Are documente',
      documents: 'Documente',
      cmrRejected: 'Refuzat',
      cmrPending: 'În curs',
      cmrUploadHint: 'Puteți încărca unul sau mai multe fișiere PDF; le vom combina într-un singur document.',
      cmrUploaded: 'Document încărcat',
      cmrUploadFailed: 'Documentul nu a putut fi încărcat: {{error}}',
      documentValidation: 'Documente',
      documentValidationNoDocuments: 'Fără documente',
      documentValidationPending: 'În curs',
      documentValidationApproved: 'Aprobat',
      documentValidationRejected: 'Respins',
      outstandingDocsTitle: 'Documents still required',
      requiredDocMissing: 'missing',
      requiredDocInReview: 'under review',
      requiredDocRejected: 'rejected — please re-upload',
      requiredDocStatusReceived: 'Received',
      requiredDocStatusInReview: 'In review',
      requiredDocStatusRejected: 'Rejected',
      requiredDocStatusMissing: 'Missing',
      requiredDocsTitle: 'Required documents',
      requiredDocsSubtitle: 'This customer requires the documents below for this order.',
      requiredDocsProgress: '{{done}} of {{total}} received',
      requiredDocReupload: 'Upload again',
      uploadDocumentTitle: 'Upload {{document}}',
      uploadRequiredDoc: 'Upload',
      uploadDocumentsTitle: 'Încarcă documente',
      uploadDocumentsHint:
        'Încărcați unul sau mai multe fișiere odată; le împărțim și atribuim fiecare parte tipului de document corect.',
      docReasonInReview: 'în verificare',
      docReasonRejected: 'respins',
      docRejectionLowQuality: 'ilizibil',
      docRejectionMissingSignature: 'lipsește semnătura',
      docRejectionNoOrderReference: 'nu s-a găsit nicio referință',
      docRejectionNotNeutral: 'CMR neneutru',
      docRejectionWrongCustomer: 'client greșit',
      docRejectionWrongDeliveryAddress: 'adresă de livrare greșită',
      docRejectionWrongDocumentType: 'tip de document greșit',
      docRejectionWrongOrgOnDocument: 'companie greșită',
      requiredDocUploaded: 'Document uploaded',
      requiredDocUploadFailed: 'Document could not be uploaded: {{error}}',
      purchases: 'Tarif de transport',
      reference: 'Referință',
      assignee: 'Atribuit la',
      orderAssigned: 'Comandă atribuită',
      changeAssignee: 'Modifică',
      assignOrder: 'Atribuie comanda',
      assign: 'Atribuie',
      route: 'Traseu',
      error: 'Eroare',
      report: 'Raport',
    },
    planning: {
      acceptAll: 'Acceptă toate',
      actions: 'Acțiuni',
      date: 'Data',
      loadingOrders: 'Se încarcă comenzile...',
      noTruck: 'Acest transportator nu are încă un camion.',
      ordersForTruck: 'Comenzi pentru camion cu numărul {{licensePlate}}',
      planning: 'Planificare',
      truck: 'Camion',
      managePlanning: 'Vizualizați și gestionați planificarea transportului',
    },
    selfBilling: {
      selfBilling: 'Autofacturare',
      rideOverview: 'Prezentare curse',
      manageRideOverview: 'Vizualizați și descărcați prezentările curselor',
      searchRideOverviewPlaceholder: 'Căutați o prezentare a curselor...',
      type: 'Tip',
      number: 'Număr',
      manageSelfBilling: 'Vizualizați și descărcați autofacturările',
      searchPlaceholder: 'Căutați o autofacturare...',
      id: 'Referință',
      date: 'Data',
      download: 'Descărcare',
      invoice: 'Factură',
      title: 'Factură de autofacturare',
    },
    businessInformation: {
      businessInformation: 'Informații despre afacere',
      settingsAndBusinessInformation: 'Setări și informații despre afacere',
      tabGeneral: 'General',
      tabFleet: 'Flotă',
      tabContacts: 'Contacte',
      civilLiabilityInsurance: 'Asigurare de răspundere civilă',
      CMRInsurance: 'Asigurare CMR',
      transportationInsurance: 'Asigurare de transport',
      documentUploaded: 'Document încărcat',
      insurances: 'Asigurări',
    },
    generalInformation: {
      generalInformation: 'Informații',
      noDocumentsAvailable: 'Nu sunt documente disponibile',
      checkBackLater: 'Reveniți mai târziu pentru documentație actualizată',
    },
    contacts: {
      contacts: 'Contacte',
      newContact: 'Contact nou',
      updateContact: 'Salvează contact',
      name: 'Nume',
      email: 'Email',
      phone: 'Telefon',
      function: 'Funcție',
      language: 'Limbă',
      delete: 'Șterge',
      createContactSuccess: 'Contact creat cu succes',
      createContactError: 'Eroare la crearea contactului: {{error}}',
      updateContactSuccess: 'Contact actualizat cu succes',
      updateContactError: 'Eroare la actualizarea contactului: {{error}}',
      deleteContact: 'Șterge contact',
      deleteContactConfirmation: 'Sunteți sigur că doriți să ștergeți contactul?',
      deleteContactSuccess: 'Contact șters cu succes',
      deleteContactError: 'Eroare la ștergerea contactului: {{error}}',
      notFound: 'Contact negăsit',
      notifications: 'Notificări',
    },
    trucks: {
      title: 'Camioane',
      newTruck: 'Camion nou',
      update: 'Actualizează camion',
      licensePlate: 'Număr de înmatriculare',
      codeName: 'Nume de cod',
      planner: 'Planificator',
      isActive: 'Activ',
      insuranceExpiresAt: 'Asigurarea expiră la',
      examinationExpiresAt: 'Inspecția expiră la',
      documents: 'Documente',
      yes: 'Da',
      no: 'Nu',
      moveUp: 'Mută sus',
      moveDown: 'Mută jos',
      create: 'Creează',
      succeeded: 'Camion salvat',
      createError: 'Nu s-a putut crea camionul: ',
      updateError: 'Nu s-a putut actualiza camionul: ',
      insurance: 'Asigurare',
      insuranceUploaded: 'Asigurare salvată',
      examination: 'Inspecție',
      examinationUploaded: 'Inspecție salvată',
      notFound: 'Niciun camion găsit',
      appLoginTitle: 'Autentificare aplicație șofer',
      appLoginHint:
        'Șoferii se autentifică cu numărul de înmatriculare. Setați parola aici; șoferii nu o pot reseta singuri.',
      appPasswordLabel: 'Parolă aplicație șofer',
      appLoginLabel: 'Autentificare (număr de înmatriculare)',
      appCodeNameLabel: 'Nume de cod',
      appSavePassword: 'Salvează parola',
      appDisableLogin: 'Dezactivează autentificarea',
      appPasswordSaved: 'Parolă salvată',
      appLoginDisabled: 'Autentificare aplicație șofer dezactivată',
      detailsTitle: 'Detalii cap tractor',
      documentCount: '{{count}} din {{total}}',
      statusValid: 'Valid',
      statusExpiringSoon: 'Expiră curând',
      statusExpired: 'Expirat',
      statusMissing: 'Lipsă',
      expiresOn: 'Expiră la {{date}}',
      noDocument: 'Niciun document încărcat',
      viewDocument: 'Vizualizare',
      replaceDocument: 'Înlocuiește',
      uploadDocument: 'Încarcă',
      searchPlaceholder: 'Caută după număr de înmatriculare…',
      noExpiryKnown: 'Nicio dată de expirare cunoscută',
      notUploadedYet: 'Încă neîncărcat',
    },
    trailers: {
      title: 'Remorci',
      truckAmount: 'Număr de camioane',
      tautlinerAmount: 'Număr de prelate',
      boxTrailerAmount: 'Număr de remorci închise/frigorifice',
      openTrailerAmount: 'Număr de remorci deschise',
      save: 'Salvează modificările',
      saveSuccess: 'Transportator actualizat',
      saveError: 'Nu s-a putut actualiza transportatorul: {{error}}',
      subtitle: 'Cantități pe tip — folosite pentru planificarea capacității',
    },
    driverBlock: {
      title: 'Acces șofer',
      message: 'Vă rugăm să vă conectați la aplicația de șofer pe telefonul mobil pentru a vizualiza comenzile.',
    },
    notFound: {
      pageNotFound: 'Pagină negăsită.',
      pageNotFoundDesc:
        'Această pagină nu pare să existe (încă). Dacă credeți că ceva este în neregulă, vă rugăm să contactați persoana de contact TransDirect.',
    },
    invite: {
      title: 'Invitat la Portalul Transportatorului',
      details: 'Ați fost invitat la portalul pentru transportatori TransDirect, creați-vă contul introducând parola.',
      accepted: 'Invitație acceptată, veți fi redirecționat la pagina principală în scurt timp.',
      acceptError: 'Nu s-a putut accepta invitația: {{error}}',
      acceptButtonText: 'Acceptă Invitația',
      password: 'Parola',
      repeatPassword: 'Repetă Parola',
    },
    users: {
      users: 'Utilizatori',
      inviteUser: 'Invită utilizator',
      invitedUsers: 'Utilizatori invitați',
      noInvitedUsers: 'Niciun utilizator invitat',
      removeInvite: 'Elimină invitația',
      confirmRemoveInvite: 'Sunteți sigur că doriți să eliminați invitația pentru {{email}}?',
      inviteRemoved: 'Invitație eliminată',
      couldNotRemoveInvite: 'Nu s-a putut elimina invitația: {{error}}',
      noUsersFound: 'Niciun utilizator găsit',
      removeUser: 'Elimină utilizator',
      confirmRemoveUser: 'Sunteți sigur că doriți să eliminați utilizatorul {{name}}?',
      userRemoved: 'Utilizator eliminat',
      couldNotRemoveUser: 'Nu s-a putut elimina utilizatorul: {{error}}',
      active: 'Activ',
      inactive: 'Inactiv',
      userInvited: 'Utilizator invitat',
      couldNotInviteUser: 'Nu s-a putut invita utilizatorul: {{error}}',
      name: 'Nume',
      email: 'Email',
      isActive: 'Este activ?',
      role: 'Rol',
      roleDispatcher: 'Dispecer',
      roleDriver: 'Șofer',
      activeUsers: 'Utilizatori activi',
      pendingInvitations: 'Invitații în așteptare',
      sendInvitation: 'Trimite invitația',
      sending: 'Se trimite...',
      cancel: 'Anulează',
      emailAddress: 'Adresă de email',
      deleteInvitation: 'Șterge invitația',
      joined: 'S-a alăturat',
      invited: 'Invitat',
      assignee: 'Atribuit la',
      assignOrder: 'Atribuie comandă',
      unassigned: 'Neatribuit',
      assignedTo: 'Atribuit la',
      roleUpdated: 'Rol actualizat',
      renameUser: 'Redenumire utilizator',
      newName: 'Nume nou',
      userRenamed: 'Utilizator redenumit',
      save: 'Salvează',
      permissions: 'Permisiuni',
      canRenameUsers: 'Poate redenumi utilizatorii',
      permissionsUpdated: 'Permisiuni actualizate',
      nameOptional: 'Nume (opțional)',
      emailRequired: 'Introduceți o adresă de e-mail',
      namePlaceholder: 'Ion Popescu',
      emailPlaceholder: 'utilizator@exemplu.com',
    },
    tracking: {
      loading: 'Se încarcă evenimentele de urmărire...',
      events: 'Evenimente de urmărire',
      noEvents: 'Nu s-au găsit evenimente de urmărire',
      scheduled: 'Programat',
      eventTypes: {
        StatusLoaded: 'Încărcat',
        StatusUnloaded: 'Descărcat',
        LocationPing: 'Actualizare locație',
      },
      stop: 'Oprire',
      by: 'de',
    },
  },
  carrierContactNotifications: {
    transportOrders: 'Comenzi de transport',
    selfBillings: 'Autofacturări',
  },
  orderStatus: {
    Draft: 'Ciornă',
    Created: 'Creat',
    Prepayment: 'Plată în avans',
    Placed: 'Plasat',
    Confirmed: 'Confirmat',
    Refused: 'Refuzat',
    Executed: 'Executat',
    Cancelled: 'Anulat',
  },
  orderSaleStatus: {
    Created: 'Creat',
    Credited: 'Creditat',
    Incomplete: 'Incomplet',
    Invoiced: 'Facturat',
  },
  customerContactNotifications: {
    invoice: 'Factură',
    orderConfirmation: 'Confirmare comandă',
    cmr: 'CMR',
    quotation: 'Ofertă',
    dieselSurcharge: 'Suprataxă motorină',
    paymentReminder: 'Memento de plată',
  },
  errors: {
    required: 'Obligatoriu',
    invalidEmail: 'Email invalid',
    dateShouldBeInTheFuture: 'Data trebuie să fie în viitor',
    startTimeShouldBeBeforeEndTime: 'Ora de începere trebuie să fie înainte de ora de încheiere',
    passwordsDontMatch: 'Parola și repetarea parolei nu se potrivesc.',
    passwordTooShort: 'Parola este prea scurtă.',
    formValidation: 'Vă rugăm să verificați câmpurile evidențiate din formular',
    retry: 'Încearcă din nou',
    reloadPage: 'Reîncarcă pagina',
    networkTitle: 'Problemă de conexiune',
    networkDescription: 'Nu putem contacta serverul. Verificați conexiunea la internet și încercați din nou.',
    serverTitle: 'Eroare server',
    serverDescription: 'Serverul nu a putut procesa solicitarea. Încercați din nou mai târziu.',
    notFoundTitle: 'Nu a fost găsit',
    notFoundDescription: 'Datele solicitate nu mai există sau nu sunt disponibile.',
    sessionTitle: 'Sesiune expirată',
    sessionDescription: 'Sesiunea a expirat sau nu sunteți autentificat. Autentificați-vă din nou pentru a continua.',
    permissionTitle: 'Fără acces',
    permissionDescription: 'Nu aveți acces la aceste date.',
    validationTitle: 'Date invalide',
    validationDescription: 'Verificați datele introduse și încercați din nou.',
    rateLimitTitle: 'Prea multe solicitări',
    rateLimitDescription: 'Au fost trimise prea multe solicitări. Așteptați puțin și încercați din nou.',
    abortedTitle: 'Solicitare anulată',
    abortedDescription: 'Solicitarea a fost anulată. Încercați din nou dacă este necesar.',
    unknownTitle: 'Eroare necunoscută',
    unknownDescription:
      'A apărut o eroare neașteptată. Încercați din nou sau contactați suportul dacă problema persistă.',
    loadingTitle: 'Încărcare eșuată',
    loadingDescription: 'Datele nu au putut fi încărcate.',
  },
  orderComplaintType: {
    Aggression: 'Agresiune fizică/verbală',
    DamagedGoods: 'Mărfuri deteriorate',
    IncorrectDelivery: 'Livrare incorectă',
    IncorrectInvoice: 'Factură incorectă',
    LateDelivery: 'Livrare cu întârziere',
    Other: 'Altele',
  },
  myProfile: {
    myProfile: 'Profilul meu',
    logout: 'Deconectare',
    name: 'Nume',
    role: 'Rol',
    email: 'Email',
    language: 'Limbă',
    languageChanged: 'Limbă actualizată',
    languageNotChanged: 'Nu s-a putut actualiza limba: {{error}}',
    joinedAt: 'Înscris la',
    nameChanged: 'Numele a fost actualizat',
    nameNotChanged: 'Nu s-a putut actualiza numele: {{error}}',
  },
  auth: {
    forgotPassword: {
      title: 'Am uitat parola',
      requestNewPassword: 'Solicită o parolă nouă',
      instructions:
        'Introduceți adresa de e-mail, dacă utilizatorul există în sistem, veți primi în curând un e-mail pentru a seta o parolă nouă.',
      requestFailed: 'Nu s-a putut solicita o parolă nouă',
      instructionsSent: 'Instrucțiunile pentru a seta o parolă nouă au fost trimise la adresa dvs. de e-mail.',
    },
    configNewPassword: {
      title: 'Setează o parolă nouă',
      newPassword: 'Parolă nouă',
      repeatNewPassword: 'Repetă parola nouă',
      confirmButtonText: 'Setează o parolă nouă',
      passwordDontMatch: 'Parola și repetarea parolei trebuie să se potrivească',
      tokenNotFound: 'Token negăsit',
      invalidToken: 'Tokenul nu mai este valid',
      configFailed: 'Nu s-a putut seta parola: {{error}}',
    },
    login: {
      login: 'Autentificare',
      email: 'Email',
      password: 'Parolă',
      forgotPassword: 'Am uitat parola',
      customerLoginTitle: 'Autentificare client',
      loginWithGoogle: 'Autentificare cu Google',
      incorrectCredentials: 'Email sau parolă incorectă',
      loginFailed: 'Nu s-a putut autentifica: {{error}}',
    },
    userNotFound: {
      title: 'Utilizator negăsit',
      description: 'Nu s-a putut autentifica, a apărut o eroare sau utilizatorul nu mai există.',
      goToLoginPage: 'Mergi la pagina de autentificare',
    },
  },
  upload: {
    title: 'Încarcă',
    dropzoneHint: 'Faceți clic aici sau trageți fișierul (fișierele) în casetă pentru a încărca',
    uploadDocuments: 'Încarcă documente',
    confirmDeleteDocument: 'Sunteți sigur că doriți să ștergeți acest document?',
    deleteDocument: 'Șterge document',
    noDocumentsFound: 'Niciun document găsit',
    noDocumentsSelected: 'Niciun document selectat',
    uploadFailed: 'Nu s-a putut încărca documentul',
    uploadDocumentFailed: 'Nu s-a putut încărca fișierul {{filename}}: {{reason}}',
    multiUploadFailed: 'Nu s-au putut încărca fișierele: {{reason}}',
  },
  or: 'sau',
  draft: 'Ciornă',
  cancel: 'Anulează',
  close: 'Închide',
  moreInfo: 'Mai multe informații',
  previous: 'Anterior',
  next: 'Următorul',
  delete: 'Șterge',
  save: 'Salvează',
  download: {
    open: 'Deschide',
    download: 'Descarcă',
    started: 'Descărcare începută',
    failed: 'Descărcare eșuată: {{message}}',
  },
  chat: {
    title: 'Chat',
    sendMessage: 'Trimite mesaj',
    placeholder: 'Scrie un mesaj...',
    noMessages: 'Niciun mesaj încă',
    loadMore: 'Încarcă mai multe mesaje',
    messageSent: 'Mesaj trimis',
    messageError: 'Mesajul nu a putut fi trimis: {{error}}',
    newMessage: '{{name}}: mesaj nou la comanda {{orderNumber}}',
    internal: 'Intern',
    carrier: 'Transportator',
  },
};
